/* @flow */
export const POST_ALERT_DATA: string = 'POST_ALERT_DATA';
export const POST_ALERT_DATA_SUCCESS: string = 'POST_ALERT_DATA_SUCCESS';
export const POST_ALERT_DATA_ERROR: string = 'POST_ALERT_DATA_ERROR';
export const CLEAR_REDUCER: string = 'CLEAR_REDUCER';
export type AlerTDATATypeAction = {
    type: string,
    payload?: Object,
};
